// Copyright (c) 2017 Deere & Company

export const buildPayload = (accounts, exportToExcel, language) => ({
    accounts: accounts.map(dealer => dealer.account),
    export: exportToExcel,
    language
});



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/services/build-payload.js